import * as E from 'fp-ts/lib/Either';

const tapLeft = <A, B>(f: (a: A) => void) => (a: E.Either<A, B>) => {
  if (E.isLeft(a)) E.mapLeft(f)(a);
  return a;
};

export default tapLeft;
